import React from 'react'
import _get from 'lodash.get'

import './styles.scss'
import NotResult from 'components/common/NotResult'
import CheckField from '../CheckField'
import { lang } from 'utils/helpers'
import SelectionBanner from '../SelectionBanner'

const TableBody = props => {
  const {
    id,
    colsToShow,
    fieldsColumns,
    active='',
    checkResult,
    results,
    actionResultCheck,
    detailResult,
    totalResult,
    originType,
    isAllSelected,
    toggleSelectedAll
  } = props

  const tdField = (res, idx, className, label, columnIndex, columnFields) => (
    <td
      key={idx}
      title={typeof label === 'string' ? label : ''}
      className={className}
      style={{
        width: columnFields?.width || null,
        paddingRight: columnIndex !== colsToShow?.length - 1 ? '10px' : null,
        textAlign: columnFields?.centered ? 'center' : null
      }}
      onClick={() => detailResult(res)}
    >
      {label}
    </td>
  )

  const getFields = (res) => {
    const cols = colsToShow.map(col => {
      const columnIndex = colsToShow.findIndex(colToShow => colToShow === col)
      const columnFields = fieldsColumns.find(({ value }) => value === col)

      if (col === 'insurance' && _get(res, 'details.insurance')) {
        return (
          <td key={col}>
            <button className='insurance-button'>
              <i className='fa fa-file-pdf-o' />
            </button>
          </td>
        )
      }

      if (Object.prototype.hasOwnProperty.call(res, col)){
        const classNameField = active === col ? 'active' : ''
        let label = ''

        switch(col){
          case 'price':
            label = res[col] !== null ? res[col].total : res[col]
            break
          case 'reservationStatus':
          case 'provider':
          case 'type':
            label = lang(res[col] === '' ? '' : `col_result_${res[col]}`)
            break
          default:
            label = res[col]
        }

        return tdField(res, col, classNameField, label, columnIndex, columnFields)
      }

      return (
        <td
          key={col}
          style={{
            width: columnFields?.width || null,
            paddingRight: columnIndex !== colsToShow?.length - 1 ? '10px' : null,
            textAlign: columnFields?.centered ? 'center' : null
          }}
        ></td>
      )
    })

    return cols
  }

  const columnsBody = () => {
    const column = []
    for(let res of results){
      column.push(
        <tr
          key={res._id}
          className='tableBodyLabel'
          style={{
            width: (colsToShow.length <=7 || fieldsColumns.every(fieldsColumn => fieldsColumn.width))
              ? '100%'
              : `${colsToShow.length * 15}%`
          }}
        >
          <td style={{ width:'40px', paddingTop:5, border: 0, cursor: 'default' }}></td>
          {originType === 'conversations' ? (
            <td style={{ width:'40px', paddingLeft:10 }}>
              <CheckField
                action={(value)=> actionResultCheck(value, res._id, false)}
                isChecked={checkResult?.includes(res._id)}
              />
            </td>
          ) : null}
          {getFields(res)}
        </tr>
      )
    }

    return column
  }

  return (
    <tbody id={id} className='detailsResults'>
      {checkResult?.length > 1 ? (
        <tr className='tr_container'>
          <td align='center'>
            <SelectionBanner
              pageCount={checkResult.length}
              totalCount={totalResult}
              isAllSelected={isAllSelected}
              toggleSelectedAll={toggleSelectedAll}
            />
          </td>
        </tr>
      ) : null}
      {!results.length ? (
        <tr className='tr_container'>
          <td>
            <NotResult />
          </td>
        </tr>
      ) : columnsBody()}
    </tbody>
  )

}

export default TableBody
